import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLockOpen,
  faIdCard,
  faUsers,
  faPeopleGroup,
  faHeart,
  faProjectDiagram,
  faCogs,
  faMapMarkerAlt,
  faCalendarAlt,
  faListAlt,
  faUser,
  faKey,
  faCog,
  faTachometerAlt,
  faFileUpload,
  faImages,
  faStream,
  faTasks
} from '@fortawesome/free-solid-svg-icons';
import './TeachableKitHome.css';
// import myprofileimage from '../../assets/pageimages/myprofileimage.webp';
import TeachableHeader from './TeachableHeader';
import HeroSection from './HeroSection';
import DocumentList from './DocumentList';
import AboutCreator from './AboutCreator';
import Pricing from './Pricing';
import Testimonials from './Testimonials';
import TeachableFooter from './TeachableFooter';

function TeachableKitHome() {
  return (
    // <MainLayout>
    //   <div className="py-8 bg-gradient-to-r from-teal-500 via-green-500 to-blue-500 mt-16">
    //     <h2 className='text-2xl font-bold text-white text-center mb-2'>Startup Kit</h2>
    //     <div className="mx-auto px-4 text-sm">
    //       <div className="flex justify-center mb-6">
    //         <img src={myprofileimage} alt="MyProfile Image" className="w-full sm:w-3/4 lg:w-1/4 rounded-lg shadow-lg" />
    //       </div>
    //       <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-8 ">
    //         <CardLink to="/myprofile-think5whyscode" icon={faLockOpen} text="My Think5Whys Code" />
    //         <CardLink to="/myprofile-profile" icon={faUser} text="My Profile" />
    //         <CardLink to="/myprofile-intern" icon={faUser} text="My Internship Profile" />
    //         <CardLink to="/myprofile-feellikeapp" icon={faCog} text="Feel Like App Setting" />
    //         <CardLink to="/contact-genious-home" icon={faIdCard} text="My Digital Card" />
    //         <CardLink to="/myprofile-ownteams" icon={faUsers} text="My Groups / Team" />
    //         <CardLink to="/myprofile-joinedteams" icon={faPeopleGroup} text="Groups / Team I have Joined" />
    //         <CardLink to="/myprofile-projects" icon={faTasks} text="My Projects" />
    //         <CardLink to="/myprofile-processes" icon={faStream} text="My Processes" />
    //         <CardLink to="/myprofile-locations" icon={faMapMarkerAlt} text="My Locations / Machines" />
    //         <CardLink to="/myprofile-changepassword" icon={faKey} text="Change Password" />
    //         <CardLink to="/myprofile-resetpassword-questions" icon={faKey} text="Reset Password Hint Questions" />
    //         <CardNoLink to="" icon={faHeart} text="IKIGAI" />
    //         <CardNoLink to="" icon={faLockOpen} text="My Orders" />
    //         <CardNoLink to="" icon={faCalendarAlt} text="My Life Stage / Life Chunk" />
    //         <CardNoLink to="" icon={faListAlt} text="My Checklists" />
    //         <CardNoLink to="" icon={faTachometerAlt} text="Configure Own Dashboard" />
    //         <CardNoLink to="" icon={faFileUpload} text="My File Uploader" />
    //       </div>
    //     </div>
    //   </div>
    // </MainLayout>
    <div className='text-white px-4 py-4'>
      <TeachableHeader/>
      <HeroSection />
      <DocumentList />
      <AboutCreator />
      <Pricing />
      <Testimonials />
      <TeachableFooter/>
    </div>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default TeachableKitHome;
